import { postersCollection } from "../config/postersConfig";

export const fetchPosters = async () => {
  return Promise.resolve(postersCollection);
};
